import request from "@/router/axios";
export const getChangeReserve = (scheduleDate, resourceId) => {
  return request({
    url: `/api/zl/bill/getChangeReserve`,
    method: "get",
    params: {
      scheduleDate: scheduleDate,
      resourceId: resourceId,
    },
  });
};
